import React, { ReactNode } from "react";
import classes from "./Buttons.module.css";

interface MenuButtonProps {
    children: ReactNode;
    onClick?: any;
    className?: string;
}
function MenuButton({ children, onClick, className }: MenuButtonProps) {
    return (
        <div
            className={[className, classes.menu_button_wrap].join(" ")}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export default MenuButton;
